// SearchPopup component - Converted from components/SearchPopup.vue
// Displays a search overlay popup that can be toggled via the store
import React from 'react';
import { useMainStore } from '../contexts/StoreContext';

const SearchPopup: React.FC = () => {
  const store = useMainStore();

  const changeMobileSearchStatus = () => {
    store.toggle();
  };

  return (
    <div className={`search-popup ${store.isActive ? 'active' : ''}`}>
      <div 
        className="search-popup__overlay custom-cursor__overlay" 
        onClick={changeMobileSearchStatus}
      />
      <div className="search-popup__inner">
        <form action="#" className="search-popup__form">
          <input type="text" name="search" placeholder="Type here to Search...." />
          <button type="submit">
            <i className="fa fa-search"></i>
          </button>
        </form>
      </div>
    </div>
  );
};

export default SearchPopup;
